// src/components/create-project/ProjectForm/steps/Step5Review.tsx
import { FC } from 'react';
import { ProjectFormData } from '@/components/create-project/types/project';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

interface Step5ReviewProps {
  formData: ProjectFormData;
}

export const Step5Review: FC<Step5ReviewProps> = ({ formData }) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Project Details</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <h4 className="font-medium">Name</h4>
              <p>{formData.name}</p>
            </div>
            <div>
              <h4 className="font-medium">Description</h4>
              <p>{formData.description}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Selected Options</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div>
              <h4 className="font-medium mb-2">Use Cases</h4>
              <div className="space-y-2">
                {formData.useCases.map(useCase => (
                  <div key={useCase} className="flex items-center gap-2">
                    <Check className="h-4 w-4 text-primary" />
                    <span>{useCase}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-medium mb-2">Content Types</h4>
              <div className="space-y-2">
                {formData.contentTypes.map(type => (
                  <div key={type} className="flex items-center gap-2">
                    <Check className="h-4 w-4 text-primary" />
                    <span>{type}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-medium mb-2">Content Structures</h4>
              <div className="space-y-2">
                {formData.contentStructures.map(structure => (
                  <div key={structure} className="flex items-center gap-2">
                    <Check className="h-4 w-4 text-primary" />
                    <span>{structure}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};